let navigateFn = null;

export const setNavigate = (fn) => {
    navigateFn = fn;
};

export const navigate = (...args) => {
    if (navigateFn) navigateFn(...args);
};
